import axios from 'axios'
import store from '@/store'
import {
  getToken,
  setToken,
  getPartnerToken,
  getSimpleToken,
  setPartnerToken,
  removeToken,
} from '@/utils/auth'

import api from '@/api/list'

import Vue from 'vue'
import { Toast } from 'vant'
import jwt_decode from 'jwt-decode'
import { router } from '../router/index.js'

Vue.use(Toast)
// 创建axios实例
const time = 5 * 60 * 1000 //超时时间5分钟
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: time,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (store.getters.enterRouteLoading) {
      store.commit('ADD_REQUEST_COUNTER')
    }
    const timeLeft = store.getters.jwtDecode.exp - Math.round(new Date() / 1000)
    let flag = true
    if (isNaN(timeLeft)) {
      flag = false
    } else {
      if (timeLeft <= 0) {
        flag = false
      }
    }
    // Do something before request is sent
    if (store.getters.token && flag) {
      // 用户端
      config.headers['Authorization'] = getToken() // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }
    if (store.getters.simpleToken) {
      // 用户端
      config.headers['token'] = getSimpleToken() // 让每个请求携带token--['token']为自定义key 请根据实际情况自行修改
    }
    if (store.getters.partnerToken) {
      // 合作方
      config.headers['partnerAuthorization'] = getPartnerToken() // 让每个请求携带token--['partnerAuthorization']为自定义key 请根据实际情况自行修改
    }

    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    store.commit('DELETE_REQUEST_COUNTER')
    /* const timeLeft = (store.getters.jwtDecode.exp - Math.round(new Date() / 1000));
  if (timeLeft <= 600 && typeof store.getters.token != 'undefined') {
    api.refreshToken({ token: store.getters.token }).then(function (response) {
      if (response.status == 200) {
        setToken(response.data.data)
        store.commit('SET_TOKEN', response.data.data);
        store.commit('SET_JWTDECODE', jwt_decode(response.data.data));
      }
    })
  }*/

    // const partnerTimeLeft = (store.getters.partnerJwtDecode.exp - Math.round(new Date() / 1000));
    // if (partnerTimeLeft <= 600 && typeof store.getters.partnerToken != 'undefined') {
    //   api.refreshPartnerToken({ token: store.getters.partnerToken }).then(function (response) {
    //     if (response.status == 200) {
    //       setPartnerToken(response.data.data)
    //       store.commit('SET_PARTNER_TOKEN', response.data.data);
    //       store.commit('SET_PARTNERJWTDECODE', jwt_decode(response.data.data));
    //     }
    //   })
    // }

    const res = response.data
    if (response.status === 401 || res.status === 40101) {
      Toast.fail('你已被登出,请重新登录！')
      store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      return Promise.reject('error')
    }

    if (res.status === 40301 || res.status === 40002) {
      if (
        response.config.url.indexOf(
          '/api/contract/taskController/addTaskApply'
        ) >= 0
      ) {
        removeToken()
        router.push({ path: '/login' })
        return Promise.reject('登录后才能申请任务')
      } else {
        if (
          response.config.url.indexOf(
            '/api/companystaff/commission/getTrendData'
          ) >= 0 ||
          response.config.url.indexOf(
            '/api/admin/user/getActiveUserPartInfo'
          ) >= 0 ||
          response.config.url.indexOf(
            '/api/companystaff/commission/getLastCommission'
          ) >= 0
        ) {
          removeToken()
          router.push({ path: '/partner_login' })
        } else {
          removeToken()
          router.push({ path: '/login' })
          return Promise.reject(
            response.config.url + ':' + response.data.message
          )
        }
        // Toast.fail('当前用户无相关操作权限！');
      }
    }

    if (res.status === 40101) {
      Toast.fail('用户认证异常，请重新登录！')
      return Promise.reject('error')
    }
    if (res.status === 40001) {
      Toast.fail(res.message)
      return Promise.reject('error')
    }
    if (res.status === 40333) {
      Toast.fail('非销售和代理商类型账号不能登录合作方平台！')
      return Promise.reject('error')
    }
    if (res.status === 40003) {
      store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      return Promise.reject('error')
    }

    if (response.status !== 200 && res.status !== 200) {
      Toast.fail(res.message)
    } else {
      return response
    }
  },
  (error) => {
    store.commit('DELETE_REQUEST_COUNTER')

    if (!error.response) {
      ErrorMessage = '系统繁忙，请稍后再试！'
      Toast.fail(ErrorMessage)
      return Promise.reject(error)
    }
    const status = error.response.status
    const res = error.response.data
    //抛出自定义异常直接返回
    if (status === 500 && res.status > 1000) {
      return error.response
    }
    let ErrorMessage = ''
    if (status == 500) {
      ErrorMessage = '系统繁忙，请稍后再试！'
    } else if (status == 503) {
      ErrorMessage = '服务器暂无响应，请稍后再试！'
    } else {
      ErrorMessage = error.message
    }
    Toast.fail(ErrorMessage)
    return Promise.reject(error)
  }
)

export default service
